import { StylesConfig, GroupBase } from 'react-select';

interface OptionType {
  value: string;
  label: string;
}

const customStyles = (isFocused: boolean): StylesConfig<OptionType, false, GroupBase<OptionType>> => {
  const getPadding = () => {
    const viewportWidth = window.innerWidth;
    const mobileBreakpoint = 576; // Breakpoint for mobile

    if (isFocused) {
      return viewportWidth <= mobileBreakpoint ? '18px 0px 0px 8px' : '18px 0px 0px 14px';
    } else {
      return viewportWidth <= mobileBreakpoint ? '6px' : '8px 14px';
    }
  };

  return {
    option: (provided, state) => ({
      ...provided,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      padding: 10,
      backgroundColor: state.isSelected ? '#00989E' : state.isFocused ? '#FFFFFF' : '#FFFFFF',
      // color: state.isSelected ? '#ffffff' : '#333333',
      color: state.isDisabled ? '#BDBDBD' : state.isSelected ? '#ffffff' : '#333333',
      marginBottom: '2px',
      zIndex: '10',
      // '&:hover': {
      //   backgroundColor: 'rgb(0 136 141 / 20%)',
      //   color: '#00989E',
      // },
      cursor: state.isDisabled ? "auto" : "pointer", // Disable the cursor
      '&:hover': {
          backgroundColor: state.isDisabled
            ? 'inherit'
            : 'rgb(0 136 141 / 20%)',
          color: state.isDisabled ? '#BDBDBD' : '#00989E',
        },
    }),
    control: (provided) => ({
      ...provided,
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      width: '100%',
      minHeight: 'unset',
      borderRadius: '5px',
      background: '#F4F4F4',
      color: '#000000',
      height: '55px',
      boxShadow: 'none',
      borderColor: '#5BCFD5',
      '&:hover': {
        border: '1px solid #5BCFD5',
      },
      '@media (max-width: 576px)': {
        height: '50px',
      },
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: getPadding(), // Use the getPadding function here
    }),
    menu: (provided, state) => ({
      ...provided,
      width: '100%',
      top: 'auto',
      bottom: state.selectProps.menuPlacement === 'top' ? '100%' : 'auto',
      marginTop: state.selectProps.menuPlacement === 'top' ? '0' : '2px',
      marginBottom: state.selectProps.menuPlacement === 'top' ? '2px' : '0',
      zIndex: 9999,
      position: 'absolute',
      left: 0,
      right: 0,
      borderRadius: '4px',
      boxShadow: '0 1px 6px rgba(0, 0, 0, 0.1)',
      backgroundColor: 'white',
      '@media (max-width: 1399.98px)': {
        bottom: 'auto',
        marginTop: '2px',
        marginBottom: '2px',
      },
      '@media (max-width: 991.98px)': {
        bottom: state.selectProps.menuPlacement === 'top' ? '100%' : 'auto',
        marginTop: state.selectProps.menuPlacement === 'top' ? '0' : '2px',
        marginBottom: state.selectProps.menuPlacement === 'top' ? '2px' : '0',
      },
      '@media (max-width: 576px)': {
        position: 'fixed',
        left: '50%',
        bottom: '50px',
        transform: 'translate(-50%, 0%)',
        height: 'auto',
        width: 'calc(100% - 50px)',
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: '#000000',
      fontSize: '17px',
      '@media (max-width: 576px)': {
        fontSize: '16px',
      },
    }),
    placeholder: (provided) => ({
      ...provided,
    }),
    clearIndicator: (provided) => ({
      ...provided,
      cursor: 'pointer',
    }),
  };
};



export default customStyles;
